import { AlertTriangle, CheckCircle2, XCircle } from "lucide-react";

export default function RulesCard({ rules, title = "ATS rules (from recruiter and ATS research)", testid = "ats-rules" }) {
  if (!rules?.length) return null;
  const passed = rules.filter((r) => r.pass).length;
  return (
    <div className="card-surface" data-testid={testid}>
      <div className="flex items-center mb-2"><div className="font-semibold">{title}</div>
        <span className="ml-auto text-xs font-mono" data-testid={`${testid}-count`}>{passed}/{rules.length} pass</span></div>
      <div className="space-y-2">
        {rules.map((r) => (
          <div key={r.id} className="flex gap-2 text-sm" data-testid={`${testid}-${r.id}`}>
            {r.pass ? <CheckCircle2 size={15} className="text-emerald-400 shrink-0 mt-0.5" /> : r.level === "blocker" ? <XCircle size={15} className="text-rose-400 shrink-0 mt-0.5" /> : <AlertTriangle size={15} className="text-amber-400 shrink-0 mt-0.5" />}
            <div className="min-w-0">
              <div className={r.pass ? "text-slate-200" : r.level === "blocker" ? "text-rose-300" : "text-amber-200"}>{r.check}{!r.pass && r.level === "blocker" && <span className="ml-2 text-[10px] uppercase tracking-wider">blocks approval</span>}</div>
              {r.detail && <div className="text-xs text-slate-400 break-words">{r.detail}</div>}
              <div className="text-[11px] text-slate-500">{r.why}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
